import React from 'react';
interface PageHeaderProps {
  title: string;
  intro?: React.ReactNode;
  children?: React.ReactNode;
}
export function PageHeader({
  title,
  intro,
  children
}: PageHeaderProps) {
  return <section className="border-b border-line bg-canvas" data-id="element-149" data-mp="3rf5hqxi79z4d">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 md:py-20" data-id="element-150" data-mp="3rcj9swredhlm">
        <h1 className="max-w-3xl font-serif text-4xl font-semibold tracking-tight text-ink md:text-5xl" data-id="element-151" data-mp="3mgu7ilnztmlm">{title}</h1>
        {intro && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-152" data-mp="2ynu5kov1ow5n">{intro}</p>}
        {children}
      </div>
    </section>;
}